import ExtraChargesDetails from './ExtraChargesDetails';

export default ExtraChargesDetails;
